/**
 * teamSettings.js — the team's display order and who's inactive for scheduling,
 * kept in one doc so the Shifts page loads it with a single read.
 *
 * Firestore: shiftSettings/team
 *   order:    [uid, …]                                  — managers arrange (👥 Team)
 *   inactive: { [uid]: { at, by, byName } }              — owner/admin only (see firestore.rules)
 *   updatedAt, updatedBy
 */
import { doc, getDoc, setDoc, updateDoc, deleteField, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase';

const teamRef = () => doc(db, 'shiftSettings', 'team');
const stamp = user => ({ updatedAt: Timestamp.now(), updatedBy: user.uid });

/** Never throws: a missing doc (or rules that don't know it yet) just means "no custom order, nobody inactive". */
export async function loadTeamSettings() {
  try {
    const snap = await getDoc(teamRef());
    const d = snap.exists() ? snap.data() : {};
    return { order: d.order || [], inactive: d.inactive || {} };
  } catch (err) {
    console.warn('team settings unavailable', err);
    return { order: [], inactive: {} };
  }
}

export function saveTeamOrder(order, user) {
  return setDoc(teamRef(), { order, ...stamp(user) }, { merge: true });
}

export function markInactive(uid, user) {
  const info = { at: Timestamp.now(), by: user.uid, byName: user.displayName || user.email || '' };
  return setDoc(teamRef(), { inactive: { [uid]: info }, ...stamp(user) }, { merge: true });
}

export function markActive(uid, user) {
  return updateDoc(teamRef(), { [`inactive.${uid}`]: deleteField(), ...stamp(user) });
}
